import React, { useState, useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
// import designSystem from 'shared/design-system/style.scss'
import styles from './Header.module.scss';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/lab/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import DropDownMenu from 'shared/components/DropDownMenu';
import NavSelect from 'shared/components/NavSelect';
//import Filters from './Filters'
import FilterList from 'shared/components/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { Link } from 'react-router-dom';

export default function Header({
  rows,
  filters,
  counter,
  columns,
  searchOptions,
  handleSearchInput,
  onFilterValue,
  onCreateMenuItemClick,
  showMoreFilters,
  setShowMoreFilters,
}) {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const handleSearchFocus = useCallback(() => {
    setIsSearchFocused(true);
  }, []);
  const handleSearchBlur = useCallback(() => {
    setIsSearchFocused(false);
  }, []);
  const handleSearchRenderInput = useCallback(
    params => (
      <Container>
        <TextField
          placeholder={isSearchFocused ? undefined : 'Search donations'}
          onFocus={handleSearchFocus}
          onBlur={handleSearchBlur}
          endAdornment={<SearchIcon />}
          {...params}
        />
      </Container>
    ),
    [handleSearchInput, isSearchFocused],
  );
  const handleShowMore = () => {
    if (window.pageYOffset > 0 && !showMoreFilters) {
      document.getElementById('h-table-root').classList.add('minified-more');
    }
    if (window.pageYOffset > 0 && showMoreFilters) {
      document.getElementById('h-table-root').classList.remove('minified-more');
    }
    setShowMoreFilters(!showMoreFilters);
  };
  const handleClear = useCallback(() => {
    push('/donor/home/by-portfolio/grid');
  }, [push]);
  const columnsMenuItems = useMemo(
    () => [
      { id: 'show_all', label: 'Show all columns' },
      { id: '-', label: '-' },
      ...(columns ?? [])?.map(({ headerName }) => ({
        id: headerName,
        label: headerName,
      })),
    ],
    [columns],
  );

  return (
    <div>
      <Root id="h-filters-root">
        <TitleRow
          id="h-filters-title"
          style={{ paddingRight: '10px', paddingLeft: '10px' }}
        >
          <Typography variant="h5" className={styles.Header}>
            Donations <Counter>({counter})</Counter>
          </Typography>
          <div style={{ marginRight: '10px' }}>
            {/* eslint-disable max-len */}
            {/*<DropDownMenu
            style={{marginRight: '5px', height: '48px', fontSize: '16px', paddingLeft: '16px', paddingRight: '16px', borderColor: '#115A79'}}
            color="primary"
            variant="outlined"
            buttonTitle="Saved Views"
            menuItems={savedViewsMenuItems}
            onMenuItemClick={() => alert('Not Implmeneted yet!')}
          />*/}
            {/* eslint-enable max-len */}
            <AddNewButton
              width={120}
              color="primary"
              variant="contained"
              buttonTitle="Add New"
              menuItems={createMenuItems}
              onMenuItemClick={onCreateMenuItemClick}
            />
          </div>
        </TitleRow>
        <Row style={{ paddingRight: '10px', paddingLeft: '10px' }}>
          <Link to="/">
            <Logo id="h-filters-logo" src="/images/logo-icon.png" />
          </Link>
          <Autocomplete
            id="donor-home-search"
            freeSolo
            options={searchOptions}
            renderInput={handleSearchRenderInput}
            onInputChange={handleSearchInput}
            forcePopupIcon
            popupIcon={<SearchIcon />}
          />
          <Label>Group by:</Label>
          <NavSelect
            name=":3"
            hasCheckbox={false}
            options={groupByOptions}
            minWidth={300}
          />
          <Label>Quick Filters:</Label>
          <NavSelect
            name="quick-filter"
            hasCheckbox={false}
            options={quickFilterOptions}
            defaultOption="all"
            minWidth={200}
          />
          <RightAlign id="h-filters-more">
            <ExpandFilters className="clear" onClick={handleClear}>
              Clear Filters
            </ExpandFilters>
            <ExpandFilters onClick={handleShowMore}>More filters</ExpandFilters>
            <SpanIcon>
              {!showMoreFilters && <ExpandMoreIcon />}
              {showMoreFilters && <ExpandLessIcon />}
            </SpanIcon>
          </RightAlign>
          <FragmentHide id="h-filters-expand">
            <ExpandFilters onClick={handleShowMore}>
              Expand/Collapse
            </ExpandFilters>
            <SpanIcon>
              <UnfoldMoreIcon />
            </SpanIcon>
          </FragmentHide>
          <FragmentHide id="h-filters-add">
            <DropDownMenu
              style={{ position: 'absolute', right: '10px' }}
              color="primary"
              variant="contained"
              buttonTitle="Add New"
              menuItems={createMenuItems}
              onMenuItemClick={onCreateMenuItemClick}
              minMenuWidth={400}
            />
          </FragmentHide>
          {/*<Filters {...{ rows, filters, onFilterValue }}/>*/}
        </Row>
        {showMoreFilters && (
          <FilterList {...{ filters, rows, onFilterValue }} />
        )}
      </Root>
      {/*<DropDownMenu
      style={{marginLeft: '10px'}}
      color="primary"
      variant="text"
      buttonTitle={<DropDownLink><ColumnsIcon/>Edit Columns</DropDownLink>}
      menuItems={columnsMenuItems}
      onMenuItemClick={() => alert('Not Implmeneted yet!')}
    />*/}
    </div>
  );
}

const DropDownLink = styled.div`
  display: flex;
  align-items: center;
`;

const Root = styled.div`
  position: relative;
  top: inherit;
  z-index: inherit;
  padding-top: 18px;
  background-color: #eaf0f6;
  width: 100%;
  padding-bottom: 14px;
  .MuiInputBase-root {
    height: 48px;
  }
  h5 {
    font-size: 32px;
    font-weight: 400;
    color: #595959;
  }
  span.MuiTypography-h6 {
    font-size: 24px;
    font-weight: 700;
    color: #99acc2;
  }
  #h-filters-title {
    margin-bottom: 12px;
  }
  label {
    font-size: 16px;
    font-weight: 700;
    color: #595959;
  }
  span.clear,
  #h-filters-more span {
    font-size: 16px;
    font-weight: 400;
    color: #0072a2;
  }
  #h-more {
    .MuiButtonBase-root {
      height: 48px;
      span.MuiButton-label {
        font-size: 16px;
        font-weight: 400;
        color: #595959;
      }
    }
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  & > *:not(first-child) {
    margin-left: 15px;
  }
  .MuiInputBase-root,
  .MuiSelect-root {
    color: #535353 !important;
    background-color: #fff !important;
  }
  .MuiAutocomplete-popupIndicatorOpen {
    transform: none !important;
  }
  margin-bottom: 5px;
`;

const Counter = styled(Typography).attrs({
  variant: 'h6',
  component: 'span',
})`
  color: #778ba5;
`;

const Container = styled.div`
  min-width: 250px;
  max-width: 400px;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  & > *:not(first-child) {
    margin-left: 10px;
  }
`;

const ExpandFilters = styled.span`
  color: #0072a2;
  cursor: pointer;
  &.clear {
    margin-right: 20px;
  }
`;

const Fragment = styled.div`
  display: contents;
  cursor: pointer;
`;

const FragmentHide = styled.div`
  display: none;
  cursor: pointer;
`;

const SpanIcon = styled.span`
  color: #0072a2;
  svg {
    font-size: 20px;
    transform: translate(5px, 3px);
    color: #0072a2;
  }
`;

const Logo = styled.img`
  height: 25px;
  transform: translateY(3px);
`;

const AddNewButton = styled(DropDownMenu)`
  height: 48px !important;
  font-size: 16px !important;
  padding-left: 16px !important;
  width: 120px !important;
  padding-right: 16px !important;
  white-space: nowrap;
`;

const groupByOptions = [
  { value: 'by-portfolio', label: 'Portfolio' },
  { value: 'by-npo', label: 'NPO' },
  { value: 'by-manager', label: 'Manager' },
  { value: 'by-status', label: 'Status' },
  { value: 'by-stage', label: 'Stage' },
  { value: 'by-service', label: 'Impact Model' },
  // { value: 'by-donation-size-d', label: 'Donation Size: $10K-$50K-$250K' },
  // { value: 'by-donation-size-a', label: 'Donation Size: $5K-$25K-$100K' },
  // { value: 'by-donation-size-b', label: 'Donation Size: $100K' },
  // { value: 'by-donation-size-c', label: 'Donation Size: $500K' },
  // { value: 'by-donation-size-4', label: 'Quartiles' },
  // { value: 'by-donation-size-5', label: 'Quantiles' },
];

const quickFilterOptions = [
  { value: 'all', label: 'Show All' },
  { value: 'mine', label: 'Show My Donations Only' },
  { value: 'overdue', label: 'Overdue Reports' },
  { value: 'feedback', label: 'Reports awaiting feedback' },
  { value: 'unsent', label: 'Unsent donation notifications' },
];

const createMenuItems = [
  { id: 'newDonation', label: 'Donation' },
  { id: 'newPortfolio', label: 'Portfolio' },
];

const savedViewsMenuItems = [
  { id: 'ph1', label: 'User Defined 1' },
  { id: 'ph2', label: 'User Defined 2' },
  { id: 'ph3', label: 'User Defined 3' },
  { id: 'ph4', label: 'Reset User Defined' },
  { id: 'ph5', label: 'Save Crurrent View...' },
];

const RightAlign = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
  align-items: center;
`;
